<template>
  <div class="homePage">首页大屏展示（暂定）</div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>